/** IST helpers. Business days (app_open once a day, seen once a day) are IST days (BR-5, BR-21). */

const IST_OFFSET_MS = 330 * 60 * 1000

/** "2026-10-19" for the Asia/Kolkata calendar day of `at`. */
export function istDay(at: Date | number = Date.now()): string {
  const ms = typeof at === 'number' ? at : at.getTime()
  return new Date(ms + IST_OFFSET_MS).toISOString().slice(0, 10)
}

/** ISO 8601 with the IST offset, e.g. "2026-10-18T10:21:00+05:30" (event `client_ts`). */
export function istIso(at: Date | number = Date.now()): string {
  const ms = typeof at === 'number' ? at : at.getTime()
  return new Date(ms + IST_OFFSET_MS).toISOString().slice(0, 19) + '+05:30'
}
